import React from 'react';

export const WhatYouGet = () => {
  const groups = [
    {
      title: 'Understand Usage',
      gradient: 'from-blue-500 to-indigo-600',
      items: [
        'Common conversation paths',
        'What users ask next',
        'Where sessions stall or end',
      ],
    },
    {
      title: 'Improve the Product',
      gradient: 'from-turret-purple to-turret-purple-light',
      items: [
        'Dead ends in conversations',
        'Confusing or missing capabilities',
        'Impact of prompt or flow changes',
      ],
    },
    {
      title: 'Communicate Insights',
      gradient: 'from-violet-500 to-purple-600',
      items: [
        'Share journeys with your team',
        'Export data to other tools',
        'Build reports around real user intent',
      ],
    },
  ];

  return (
    <section className="py-32 md:py-40 bg-gradient-to-b from-white via-slate-50/50 to-white relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-turret-purple/5 rounded-full blur-[120px] -translate-y-1/2 translate-x-1/2" />
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-indigo-500/5 rounded-full blur-[100px] translate-y-1/2 -translate-x-1/2" />

      <div className="section-container relative z-10">
        <div className="text-center mb-20">
          <p className="text-turret-purple font-semibold tracking-wide uppercase text-sm mb-4">
            Capabilities
          </p>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-neutral-900 tracking-tight mb-6">
            Answer questions you can't today
          </h2>
          <p className="text-xl text-neutral-500 max-w-xl mx-auto">
            Unlock insights hidden in your conversations
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 lg:gap-8 max-w-6xl mx-auto">
          {groups.map((group, index) => (
            <div
              key={index}
              className="group relative"
            >
              {/* Glow effect on hover */}
              <div className={`absolute -inset-2 bg-gradient-to-b ${group.gradient} rounded-[32px] opacity-0 group-hover:opacity-[0.08] blur-2xl transition-opacity duration-700`} />
              
              <div className="relative h-full p-8 lg:p-10 rounded-[28px] bg-white border border-slate-200/80 hover:border-slate-300/90 shadow-sm hover:shadow-[0_8px_30px_rgb(0,0,0,0.06)] transition-all duration-500">
                {/* Gradient header bar */}
                <div className={`h-1.5 w-16 rounded-full bg-gradient-to-r ${group.gradient} mb-8`} />

                <h3 className="text-2xl font-semibold text-neutral-900 mb-8 tracking-tight">
                  {group.title}
                </h3>

                <ul className="space-y-5">
                  {group.items.map((item, itemIndex) => (
                    <li key={itemIndex} className="flex items-start gap-4">
                      <div className="flex-shrink-0 w-6 h-6 rounded-full bg-slate-100 flex items-center justify-center mt-0.5">
                        <svg
                          className="w-3.5 h-3.5 text-turret-purple"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2.5"
                            d="M5 13l4 4L19 7"
                          />
                        </svg>
                      </div>
                      <span className="text-neutral-600 leading-relaxed">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
